import { forwardRef, useEffect, useState } from "react";
import {
  Chip,
  Dialog,
  DialogContent,
  LinearProgress,
  Slide,
  Stack,
  Typography,
} from "@mui/material";
import { factory } from "../../../../../api/apiFactory";
import { parseSerials } from "../../../../../helpers/serials";

const productApi = factory.get("product");

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Read-only list of the serials of one product that one user currently holds.
const SerialsDialog = ({ row, onClose }) => {
  const [serials, setSerials] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!row) return;
    let cancelled = false;
    setLoading(true);
    productApi
      .serials({ product_id: row.product_id, user_id: row.user_id })
      .then((res) => !cancelled && setSerials(parseSerials(res)))
      .catch(() => !cancelled && setSerials([]))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [row]);

  return (
    <Dialog
      open={Boolean(row)}
      TransitionComponent={Transition}
      fullWidth
      dir="rtl"
      onClose={onClose}
    >
      <DialogContent>
        <Typography variant="h4" color="purple" gutterBottom component="div">
          الارقام التسلسلية
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={2}>
          {`${row?.product_name ?? ""} - ${row?.user_name ?? ""}`}
        </Typography>
        {loading && <LinearProgress sx={{ mb: 2 }} />}
        <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", rowGap: 1 }}>
          {serials.length > 0 ? (
            serials.map((serial) => (
              <Chip key={serial.id} label={serial.serial_number} />
            ))
          ) : loading ? null : (
            <Typography variant="body2">لا توجد ارقام تسلسلية</Typography>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default SerialsDialog;
